import translate from "@/i18n/translate";
import { Table, formatDateFullYear } from "../../common/helper";
import {
  SettingsReportingYear,
  SettingsTerm
} from "@/features/common/interfaces/Interface";
import { WmButton } from "@watermarkinsights/ripple-react";
import { useIntl } from "react-intl";

const getTableColumns = () => {
  return [
    translate("app.settings.reportingYear"),
    translate("app.settings.dateRange"),
    translate("app.settings.Terms")
  ];
};

export const TableHeader = (props: any) => {
  return (
    <thead className="dataheader">
      <tr className="dataheaderrow">
        {props.columns.map((columnName: any, index: number) => {
          return (
            <th
              key={`${index} ${columnName}`}
              className="dataheadercell"
              data-th={columnName}
            >
              <span>{columnName}</span>
              {index === 1 && (
                <span className="mdi mdi-arrow-down sort-arrow-down"></span>
              )}
            </th>
          );
        })}
        <th className="dataheadercell"></th>
      </tr>
    </thead>
  );
};

const TableBody = ({
  reportingYears,
  editReportingYearModal
}: reportingYearTableProps) => {
  const edit = useIntl().formatMessage({
    id: "app.settings.edit"
  });

  return (
    <tbody className="databody">
      {reportingYears?.map(
        (reportingYear: SettingsReportingYear, index: number) => {
          return (
            <tr
              key={`reporting year - ${reportingYear.uuid}`}
              className="datarow"
            >
              <td className="datacell">
                <div>{reportingYear.name}</div>
                <div>
                  {translate("app.settings.code", { code: reportingYear.code })}
                </div>
              </td>
              <td className="datacell">{`${formatDateFullYear(
                reportingYear.startDate
              )} - ${formatDateFullYear(reportingYear.endDate)}`}</td>
              <td className="datacell">
                {reportingYear.terms.map((term: SettingsTerm) => {
                  return <RenderTerms key={`${term.uuid}`} term={term} />;
                })}
              </td>
              <td className="datacell datacell-icon">
                <WmButton
                  button-type="icononly"
                  tooltip={`${edit} ${reportingYear.name}`}
                  icon="f3eb"
                  icon-size="18px"
                  onClick={() => editReportingYearModal(reportingYear)}
                ></WmButton>
              </td>
            </tr>
          );
        }
      )}
    </tbody>
  );
};

interface renderTermsProps {
  term: SettingsTerm;
}

function RenderTerms({ term }: renderTermsProps) {
  return (
    <div>{`${term.name} ( ${formatDateFullYear(
      term.startDate
    )} - ${formatDateFullYear(term.endDate)} )`}</div>
  );
}

interface reportingYearTableProps {
  reportingYears: SettingsReportingYear[] | null;
  editReportingYearModal: (reportingYear: SettingsReportingYear) => void;
}
export default function ReportingYearTable({
  reportingYears,
  editReportingYearModal
}: reportingYearTableProps) {
  return (
    <Table>
      <TableHeader columns={getTableColumns()} />
      <TableBody
        reportingYears={reportingYears}
        editReportingYearModal={editReportingYearModal}
      />
    </Table>
  );
}
